
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accountants",
      function () {
        return require("private-next-pages/accountants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accountants"])
      });
    }
  